import React from 'react';
import { Loading } from 'common/ui/Loading';
import { CandidateBatch, AutomationType } from 'generated-graphql/types';
import { RulesSettings } from './RulesSettings';
import { useAnalysisAutomationTasks } from 'modules/analyse/hooks/useAnalysisAutomationTasks';
import { useDrawer } from 'services/drawer/hooks';
import { AutomationDrawerContainer } from './AutomationDrawerContainer';

const minWidth = '750px';

type Props = {
  candidateBatch: CandidateBatch;
  setCandidateBatch: (candidateBatch: CandidateBatch) => void;
};

export const AnalysisRulesDrawer: React.FC<Props> = ({
  candidateBatch,
  setCandidateBatch
}) => {
  const { forceCloseDrawer, updateDrawerProps } = useDrawer();

  const { formik, onFormChanged, loading, isSubmitting } =
    useAnalysisAutomationTasks({
      candidateBatch,
      setCandidateBatch,
      automationType: AutomationType.Rule
    });

  const handleOverrideChecked = (value: any) => {
    formik.setFieldValue('overwriteLockedCandidates', value);
    if (value) {
      updateDrawerProps({
        preventClose: true,
        confirmationModalProps: {
          title: 'Save changes?',
          confirmationText: 'Confirm',
          cancelText: 'Cancel',
          onConfirm: () => {
            formik.submitForm();
          }
        }
      });
    } else {
      updateDrawerProps({
        preventClose: false
      });
    }
  };

  if (loading) {
    return (
      <Loading
        containerSx={{
          minWidth
        }}
      />
    );
  }

  return (
    <AutomationDrawerContainer
      title="Rules"
      subtitle="Change applicant status based on their performance"
      candidateBatch={candidateBatch}
      loading={loading}
      isSubmitting={isSubmitting}
      onSubmit={formik.submitForm}
      onCancel={forceCloseDrawer}
      overrideCheckedValue={formik.values.overwriteLockedCandidates}
      handleOverrideChecked={handleOverrideChecked}
    >
      <RulesSettings
        candidateBatchId={candidateBatch.id}
        analysisAutomationItems={formik.values.automationTasks}
        onFormChange={(values) => {
          formik.setFieldValue('automationTasks', values);
          onFormChanged(values);
        }}
      />
    </AutomationDrawerContainer>
  );
};
